import React from 'react'


/* Create By Poom : 07-07-2023 */
function Timesheet_SubmitCellShowTime(props) {
    
    const { hh 
        ,mm
     } = props;


  return (
    <>
        <span>
            {(hh > 0 &&
            <>
                {hh}<span className="text-small text-normal">h</span>
            </>)}
            {(hh > 0 && mm >0) && 
            <>
                {"  "}
            </>}
            {(mm > 0 &&
            <>
                {mm}<span className="text-small text-normal">m</span>
            </>)}
        </span>
    </>
  )
}

export default Timesheet_SubmitCellShowTime